import { AttachmentsList } from './components/AttachmentsList'

export default AttachmentsList
